import { useEffect, useState } from 'react';
import { useWindowDimensions } from 'react-native';

export function useDebounced<T>(value: T, ms = 300): T {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return v;
}

export const BREAKPOINTS = { sm: 640, md: 900, lg: 1024 } as const;

/** Responsive helpers. `isWide` (>= 1024) switches the shell to sidebar layout. */
export function useBreakpoint() {
  const { width, height } = useWindowDimensions();
  return {
    width,
    height,
    isPhone: width < BREAKPOINTS.sm,
    isTablet: width >= BREAKPOINTS.md,
    isWide: width >= BREAKPOINTS.lg,
  };
}

export function useNow(intervalMs = 1000) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(t);
  }, [intervalMs]);
  return now;
}
